(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-recommendations"] && !Shopify.designMode) return;
  try {
    // In the cart drawer, the + opens the quick view: assets/cart-drawer.js handles the click first
  // and marks it handled. Anywhere else (the cart page's own row, which has no drawer to swap) the
  // + follows the product link, so it is never a dead control. Delegated, because the row is
  // re-rendered after every cart change.
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('.cart-recs__quick[data-quick-view]');
    if (!(button instanceof HTMLElement) || event.defaultPrevented) return;
    const url = button.dataset.productUrl;
    if (url) window.location.assign(url);
  });
  } catch(e) { console.error(e); }
})();

})();
